import { Routes, RouterModule } from '@angular/router';

import { ProfileComponent } from './components/app/profile.component';
import { NavigationFilterGuard } from '@iws-ux/auth';

const appRoutes: Routes = [
    {
        path: '', canActivateChild: [NavigationFilterGuard], children: [
            { path: '', redirectTo:'dashboard', data: { title: 'Home' }, pathMatch: 'full' },
            { path: 'home', redirectTo:'dashboard', data: { title: 'Home' } },
            { path: 'signin-oidc', redirectTo:'dashboard', data: { title: 'Home' } },
            { path: 'profile', component: ProfileComponent, data: { title: 'Profile' } },
            {
                path: 'dashboard',
                loadChildren: () => import('./components/dashboard/dashboard.module')
                    .then(m => m.ProcessModule)
            },
            {
                path: 'process',
                loadChildren: () => import('./components/process/process.module')
                    .then(m => m.ProcessModule)
            },
            {
                path: 'settings',
                loadChildren: () => import('./components/settings/settings.module')
                    .then(m => m.SettingsModule)
            },
            {
                path: 'analysis',
                loadChildren: () => import('./components/analysis/analysis.module')
                    .then(m => m.AnalysisModule)
            },
            {
                path: 'vault',
                loadChildren: () => import('./components/vault/vault.module')
                    .then(m => m.VaultModule)
            },
        ]
    }
];

export const routing = RouterModule.forRoot(appRoutes, {});
